function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#B7BCC7",
  strokeWidth: 2,
  strokeLinecap: "square",
  cx: 9.429,
  cy: 15.429,
  r: 1.714
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#B7BCC7",
  strokeWidth: 2,
  strokeLinecap: "square",
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.286 15.429a5.28 5.28 0 016 .857M18 30.857a8.571 8.571 0 008.571-8.571H9.43A8.571 8.571 0 0018 30.857h0z",
  stroke: "#B7BCC7",
  strokeWidth: 2,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#B7BCC7",
  fillRule: "nonzero",
  cx: 9.429,
  cy: 15.429,
  r: 1.714
}));

function SvgWink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxjaXJjbGUgc3Ryb2tlPSIjQjdCQ0M3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGN4PSI5LjQyOSIgY3k9IjE1LjQyOSIgcj0iMS43MTQiLz4KICAgIDxjaXJjbGUgc3Ryb2tlPSIjQjdCQ0M3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPgogICAgPHBhdGggZD0iTTIyLjI4NiAxNS40MjlhNS4yOCA1LjI4IDAgMDE2IC44NTdNMTggMzAuODU3YTguNTcxIDguNTcxIDAgMDA4LjU3MS04LjU3MUg5LjQzQTguNTcxIDguNTcxIDAgMDAxOCAzMC44NTdoMHoiIHN0cm9rZT0iI0I3QkNDNyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CiAgICA8Y2lyY2xlIGZpbGw9IiNCN0JDQzciIGZpbGwtcnVsZT0ibm9uemVybyIgY3g9IjkuNDI5IiBjeT0iMTUuNDI5IiByPSIxLjcxNCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgWink as ReactComponent };